export const PER_PAGE = {
  zero: 0,
  one: 1,
  three: 3,
  four: 4,
  five: 5,
  six: 6,
  eight: 8,
  ten: 10,
  twelve: 12,
  twenty: 20,
  hundred: 100,
  infinity: -1,
};
